import Iconify from '../components/Iconify';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export function formatDateMonth(monthIndex) {
  var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  return monthNames[monthIndex];
}

export function formatDate(date) {
  var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();

  var hours = date.getHours();
  var minutes = date.getMinutes();
  // var seconds = date.getSeconds();
  // Aug 2 2019 at 12:12
  return `${day} ${monthNames[monthIndex]}, ${year} ${hours}:${minutes}`;
}

export const sessions = [2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034];

export const examSetList = ['A', 'B', 'C', 'D', 'E', 'F'];

export const nextStep = ['Call Again', 'Check Payment', 'Admit to Course', 'Decline Registration', 'Others'];

export const applicationStatus = ['New', 'Admitted', 'Declined', 'Banned'];

export const courseTypes = [
  'Mobile Scan OMR Course',
  'Offline Class Course',
  'Online Video Content Course',
  'Exam Batch',
];

export const paymentMethods = ['Cash', 'Bank', 'BKash', 'Nagad', 'Rocket', 'Others'];
export const paymentTypes = ['One-Time', 'Monthly'];
export const paymentMonth = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const activeStatus = ['true', 'false'];

export const paymentStatusList = ['paid', 'unpaid'];

export const emptyQuestion = {
  question: '',
  titleImage: null,
  options: [
    {
      title: '',
      titleImage: null,
    },
    {
      title: '',
      titleImage: null,
    },
    {
      title: '',
      titleImage: null,
    },
    {
      title: '',
      titleImage: null,
    },
  ],
};

export const getDashboardBase = () => {
  const mode = localStorage.getItem('dashboardMode');
  return mode === 'cool' ? '/cool-dashboard' : '/dashboard';
};

export const getNavElementsForAdmin = (roleSet) => {
  const base = getDashboardBase();
  const navElements = [];

  if (roleSet.length === 0) {
    return navElements;
  }

  if (roleSet.includes('CHECK_OTHER_INSTITUTE')) {
    navElements.push({
      title: 'Switch Institute',
      path: `${base}/switchInstitute`,
      icon: getIcon('icon-park-outline:change'),
    });
  }

  navElements.push(
    {
      title: 'dashboard',
      path: `${base}/app`,
      icon: getIcon('eva:pie-chart-2-fill'),
    },
    {
      title: 'Students',
      path: `${base}/user`,
      icon: getIcon('solar:user-check-bold'),
    },
    {
      title: 'Online Exam',
      path: `${base}/onlineExam`,
      icon: getIcon('healthicons:i-exam-multiple-choice'),
    },
    {
      title: 'Course Details',
      path: `${base}/courseList`,
      icon: getIcon('healthicons:i-exam-multiple-choice'),
    },
  );

  if (roleSet.includes('CREATE_AND_UPDATE_COURSE') || roleSet.includes('RAASHID_SUPER_ADMIN')) {
    navElements.push({
      title: 'Teacher Management',
      path: `${base}/teacherEnrollment`,
      icon: getIcon('mdi:account-tie'),
    });
  }

  navElements.push(
    {
      title: 'New/Block Students',
      path: `${base}/unverified/students`,
      icon: getIcon('eva:people-fill'),
    },
    {
      title: 'Institute',
      path: `${base}/institute`,
      icon: getIcon('mdi:home'),
    },
    {
      title: 'SMS System',
      path: `${base}/smsSystem`,
      icon: getIcon('fa-solid:sms'),
    },
    {
      title: 'Dynamic SMS',
      path: `${base}/dynamicSmsSystem`,
      icon: getIcon('subway:sms-1'),
    },
    {
      title: 'Course Registrations',
      path: `${base}/course_enrollments`,
      icon: getIcon('hugeicons:course'),
    },
    {
      title: 'Student Admission',
      path: `${base}/register_student`,
      icon: getIcon('eva:person-add-fill'),
    },
  );

  if(roleSet.includes('MOBILE_OMR_SCAN')){
    navElements.push({
      title: 'QR Code Generation',
      path: `${base}/qrGeneratorPage`,
      icon: getIcon('hugeicons:course'),
    })
  }

  if (roleSet.includes('EDIT_PAYMENT') || roleSet.includes('VIEW_PAYMENT')) {
    navElements.push(
      {
        title: 'Collected Payments',
        path: `${base}/payment`,
        icon: getIcon('mdi:currency-bdt'),
      },

      {
        title: 'Due Payments',
        path: `${base}/due-payment`,
        icon: getIcon('mdi:currency-bdt'),
      }
      // {
      //   title: 'Batchwise Payment',
      //   path: `${base}/batchWisePaymentSummary`,
      //   icon: getIcon('fluent:wallet-credit-card-28-filled'),
      // },
    );
  }

  // if (roleSet.includes('VIEW_PAYMENT')) {
  //   navElements.push({
  //     title: 'Due Payments',
  //     path: `${base}/due-payment`,
  //     icon: getIcon('mdi:currency-bdt'),
  //   });
  // }

  if (roleSet.includes('RAASHID_SUPER_ADMIN')) {
    navElements.push({
      title: 'Configs',
      path: `${base}/omrPointsEditor`,
      icon: getIcon('eva:settings-2-fill'),
      children: [
        {
          title: 'OMR Points Config',
          path: `${base}/omrPointsEditor`,
        },
        {
          title: 'Admin Roles',
          path: `${base}/adminRoles`,
        },
        {
          title: 'Institution Config',
          path: `${base}/institutionConfig`,
        },
        {
          title: 'System Health',
          path: `${base}/systemHealth`,
        },
        {
          title: 'Register Admin',
          path: `${base}/adminRegistration`,
        },
        {
          title: 'OMR Scan Logs',
          path: `${base}/omrScanLogs`,
        },
        {
          title: 'App Logs',
          path: `${base}/appLogs`,
        },
      ],
    });
  }

  return navElements;
};
